export default __webpack_public_path__ + "static/media/edit.042a8dd8.svg";